import React, { FC } from 'react';
import { TextButton } from 'wix-ui-tpa/cssVars';
import { classes, st } from './ReadMoreLink.st.css';

export type ReadMoreLinkProps = {
  slotId: string;
  readMoreText?: string;
  readMoreAriaLabel?: string;
  onReadMoreClick?: (slotId: string) => Promise<void>;
  theme?: 'default' | 'onImage';
};

export const ReadMoreLink: FC<ReadMoreLinkProps> = ({
  slotId,
  readMoreText,
  readMoreAriaLabel,
  onReadMoreClick,
  theme = 'default',
}) => {
  if (!readMoreText || !onReadMoreClick) {
    return null;
  }

  return (
    <div className={st(classes.root, { onImage: theme === 'onImage' })}>
      <TextButton
        className={classes.link}
        aria-label={readMoreAriaLabel}
        data-hook="agenda-item-read-more-link"
        onClick={() => onReadMoreClick(slotId)}
      >
        {readMoreText}
      </TextButton>
    </div>
  );
};
